/** @jsxImportSource @emotion/react */
'use client';

import React from 'react';
import { IconSlot, StyledBadge } from './styled';
import type { BadgeProps } from './types';

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  (
    {
      children,
      intent = 'dark',
      variant = 'success',
      size = 'sm',
      shape = 'rounded',
      icon,
      uppercase = true,
      as,
      className,
      testId = 'badge',
      css,
      style,
      ...rest
    },
    ref
  ) => {
    return (
      <StyledBadge
        ref={ref}
        as={as}
        data-testid={testId}
        data-intent={intent}
        data-variant={intent === 'subtle' ? variant : undefined}
        data-size={size}
        data-shape={shape}
        $intent={intent}
        $variant={variant}
        $size={size}
        $shape={shape}
        $uppercase={uppercase}
        className={className}
        css={css}
        style={style}
        {...rest}
      >
        {icon ? <IconSlot aria-hidden>{icon}</IconSlot> : null}
        {children}
      </StyledBadge>
    );
  }
);

Badge.displayName = 'Badge';
